import { InlineSearchField } from "@/components/ui/controls/searchfield";

export const CHOOSE_TEMPLATE_SECTION_DESCRIPTION =
  "Start from a template. The layout is fixed — you’ll configure what each section says, who receives it and when.";

export interface ChooseTemplateSectionHeaderProps {
  searchTerm: string;
  onSearchTermChange: (value: string) => void;
}

export const ChooseTemplateSectionHeader = ({
  searchTerm,
  onSearchTermChange,
}: ChooseTemplateSectionHeaderProps) => (
  <header className="shrink-0 bg-white pt-5 pb-6 pl-19 pr-16">
    <div className="flex flex-col gap-4 sm:flex-row sm:items-start sm:justify-between">
      <div className="flex flex-col gap-2">
        <h1 className="text-xl font-medium leading-4 text-gray-900">
          Choose template
        </h1>
        <p className="max-w-146.25 text-sm leading-5 tracking-[0.14px] text-gray-700">
          {CHOOSE_TEMPLATE_SECTION_DESCRIPTION}
        </p>
      </div>
      <div className="flex w-full flex-col items-stretch sm:w-auto sm:items-end">
        <InlineSearchField
          ariaLabel="Search templates"
          clearAriaLabel="Clear template search"
          value={searchTerm}
          onValueChange={onSearchTermChange}
        />
      </div>
    </div>
  </header>
);
